import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import { AvatarDropdown, AvatarName, } from '@/components';
import { IconFont } from '@gatherstar/components';
import defaultSettings from '../config/defaultSettings';
import { requestConfig } from './requestConfig';
import '@ant-design/v5-patch-for-react-19';
import { Navigate } from '@umijs/max';
import type { MenuItemDTO } from '@/services/data-contracts';

const loginPath = '/user/login';

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  userMenus?: MenuItemDTO[];
  loading?: boolean;
  fetchUserInfo?: () => Promise<any | undefined>;
}> {
  const fetchUserInfo = () => {
    try {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        return JSON.parse(userInfo);
      }
      return {};
    } catch (error) {
      console.error(error);
      return {};
    }
  };

  // 获取用户菜单权限（从本地缓存读取）
  const fetchUserMenus = (): MenuItemDTO[] => {
    try {
      const cachedMenus = localStorage.getItem('userMenus');
      if (cachedMenus) {
        return JSON.parse(cachedMenus);
      }
      return [];
    } catch (error) {
      console.error('读取菜单权限缓存失败:', error);
      return [];
    }
  };

  // 如果不是登录页面，执行
  const { location } = history;
  if (![loginPath, '/user/register', '/user/register-result'].includes(location.pathname)) {
    const currentUser = await fetchUserInfo();
    const userMenus = fetchUserMenus();

    return {
      fetchUserInfo,
      currentUser,
      userMenus,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}


// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    // actionsRender: () => [<Question key="doc" />],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName/>,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    // 自定义 logo 点击事件，跳转到首页
    onMenuHeaderClick: () => {
      history.push('/dashboard');
    },
    // 自定义菜单项渲染，支持自定义图标
    menuItemRender: (itemProps, defaultDom) => {
      if (itemProps.isUrl || !itemProps.path) {
        return defaultDom;
      }
      return (
        <Link to={itemProps.path}>
          {itemProps.pro_layout_parentKeys && itemProps.pro_layout_parentKeys.length > 0 ? (
            // 子菜单，不显示图标
            defaultDom
          ) : (
            // 一级菜单，显示自定义图标
            <>
              {itemProps.icon && typeof itemProps.icon === 'string' && (
                <IconFont type={itemProps.icon}/>
              )}
              <span>{itemProps.name}</span>
            </>
          )}
        </Link>
      );
    },
    // 自定义子菜单（有子项的菜单）渲染，支持自定义图标
    subMenuItemRender: (itemProps, defaultDom) => {
      return (
        <span>
          {itemProps.icon && typeof itemProps.icon === 'string' && (
            <IconFont type={itemProps.icon}/>
          )}
          <span>{itemProps.name}</span>
        </span>
      );
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name,
    // },
    // footerRender: () => <Footer />,
    onPageChange: () => {
    },
    bgLayoutImgList: [],
    links: [],
    siderWidth: 200,
    menuHeaderRender: undefined,
    unAccessible: <Navigate to='/' replace={true}/>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
        </>
      );
    },
    ...initialState?.settings,
  };
};

export function onRouteChange({ location, routes }: any) {
  const token = localStorage.getItem('token');
  // 如果没有登录，重定向到 login
  if (!token && location.pathname !== loginPath) {
    history.replace(loginPath);
  }
}

export const request: RequestConfig = requestConfig
